import createCache from '@emotion/cache';
import { EmotionCache } from '@emotion/react';

const createEmotionCache = () => {
  return createCache({
    key: 'css',
  });
};

// Puts the emotion styles before the meta and link tags so that they cannot be found correctly when hydrating
// prepend: true,

export default createEmotionCache;